import React, { Component } from 'react'
import { SearchBar, Featured, SearchList, Poll } from './../../../components'
import { SearchStyle } from './../../../styles'
import ReactGA from 'react-ga'

export default class Search extends Component {
  state = {
    search: ''
  }
  
  static defaultProps = {
    home: true
  }

  componentDidMount() {
    ReactGA.pageview('/');
  }

  searchCallback = (data) => {
    this.setState({ search: data })
  }

  render() {
    const { home } = this.props
    const { search } = this.state
    return (
      <div className={`search ${SearchStyle(search !== '')}`}>
        <SearchBar callback={this.searchCallback} />
        <div className="home-featured">
          <Featured home={home} />
        </div>
        <div className="home-search-list">
          <SearchList search={search} />
        </div>
        <Poll />        
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Search.js